var map = {
	"./boutique.svg": 4374,
	"./chef.svg": 7819,
	"./curtain.svg": 4387,
	"./fashion-designer.svg": 8446,
	"./measure.svg": 7422,
	"./measuring-tape.svg": 5136,
	"./needle.svg": 6726,
	"./sewing.svg": 642,
	"./t-shirt.svg": 5072,
	"./uniform.svg": 3021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3833;